import { axios } from '/plugins/axios.client';
import { toast } from '/plugins/toaster.client.js';
import { i18n } from '/plugins/i18n.client';
import { errorFromResponse } from '/src/common/general-utils';
import { widgetForState } from '/src/features/widgets/edit/widget-helper';

const errorHandler = errorFromResponse(i18n.global.t.bind(i18n));

export const fetchTableFields = async (tableName, skipTableNameCheck) => {
  try {
    return await axios.$get(`/api/profiler-table`, { params: { tableName, skipTableNameCheck } });
  } catch (e) {
    return [];
  }
};

export const getWidget = async (widgetUUID, isEmbedded = false, fromCockpit = false) => {
  let widget;
  try {
    widget = widgetForState(
      await axios.$get(`/api/v2/widgets/${widgetUUID}/byRef`, {
        headers: { 'is-embedded': isEmbedded, 'from-cockpit': fromCockpit }
      })
    );
  } catch (error) {
    toast.error(
      errorHandler(
        i18n.global.t('admin.dynamic_labels.fetch_action', {
          feature: i18n.global.t('admin.feature.widgets')
        }),
        error
      )
    );
  }
  return widget;
};
